// components
import { InputSearch } from '@commons/modules/Settings/InputSearch';
import { DropdownClientFilter } from '../DropdownClientFilter';
// styles
import styles from './SearchBar.module.css';

const SearchBar = ({ searchValue, setSearchValue, clearSearch, setClientIdFilter, handleFetch, resetClientFilter }) => {
    return (
        <div className={styles['wrapper']}>
            <p className={styles['title']}>Puntos de venta deshabilitados</p>
            <div className={styles['container-filters']}>
                <DropdownClientFilter
                    setClientIdFilter={setClientIdFilter}
                    handleFetch={handleFetch}
                    resetClientFilter={resetClientFilter}
                />
                <InputSearch
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                    clearSearch={clearSearch}
                    loading={false}
                    width={340}
                />
            </div>
        </div>
    );
};

export default SearchBar;
